<template>
  <div class="sidebar" v-if="userRole">
    <template v-for="(item, index) in filteredLinks" :key="index">
      <router-link
        v-if="item.type !== 'raw'"
        :to="{ name: item.name }"
        :class="{ active: currentRouteName === item.name }"
      >
        <i :class="item.icon"></i>
        <span>{{ item.textKey ? $t(item.textKey) : item.text }}</span>
      </router-link>
      <a v-else>
        <i :class="item.icon"></i>
        <span>{{ item.text }}</span>
      </a>
    </template>
  </div>
</template>

<script>
export default {
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    userRole() {
      const roles = this.$store.getters.getAuthRole;
      return roles && roles.length ? roles[0] : null;
    },
    filteredLinks() {
      const role = this.userRole;
      if (!role) return [];

      const allLinks = [
        {
          name: 'adminNewRegistor',
          icon: 'fas fa-bell',
          textKey: 'message.recent_registration_information',
          roles: ['supperAdmin', 'Admin']
        },
        {
          name: 'adminTrainingGroup',
          icon: 'fas fa-list-alt',
          textKey: 'message.training',
          roles: ['supperAdmin', 'Admin']
        },
        {
          name: 'approvePerson',
          icon: 'fas fa-calendar-check',
          textKey: 'message.expiration',
          roles: ['supperAdmin', 'Admin']
        },
        {
          name: 'alertExpiration',
          icon: 'fas fa-exclamation-triangle',
          textKey: 'message.alert_expiration',
          roles: ['supperAdmin', 'Admin']
        },
        {
          name: 'invoiceManagement',
          icon: 'fas fa-dollar-sign',
          textKey: 'message.invoice_mangement',
          roles: ['supperAdmin', 'Account']
        },
        {
          type: 'raw',
          icon: 'fas fa-user-friends',
          text: 'បញ្ជីអ្នកប្រើប្រាស់',
          roles: ['supperAdmin']
        },
        // {
        //   name: 'reminder',
        //   icon: 'fas fa-stopwatch',
        //   textKey: 'message.reminder',
        //   roles: ['Admin']
        // },
        {
          name: 'personalInfo',
          icon: 'fas fa-user',
          textKey: 'message.personal_info',
          roles: ['supperAdmin', 'Admin', 'Account']
        },
        {
          name: 'adminChangePassword',
          icon: 'fas fa-key',
          textKey: 'message.change_password',
          roles: ['supperAdmin', 'Admin', 'Account']
        }
      ];

      return allLinks.filter(link => link.roles.includes(role));
    }
  }
};
</script>

<style scoped>
.sidebar {
  margin: 0;
  padding: 24px 0;
  width: 200px;
  background: linear-gradient(180deg, #09140e 0%, #050b07 100%);
  position: absolute;
  height: 100%;
  overflow-y: auto;
  box-shadow: 4px 0 25px rgba(0, 0, 0, 0.3);
  font-family: "Battambang", Avenir, Helvetica, Arial, sans-serif;
  border-right: 1px solid rgba(255, 255, 255, 0.05);
}

.sidebar a {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.65);
  margin: 6px 12px;
  padding: 12px 16px;
  text-decoration: none;
  border-radius: 8px;
  font-size: 13.5px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.sidebar a i {
  font-size: 15px;
  transition: transform 0.25s ease, color 0.25s ease;
  width: 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
}

.sidebar a.active {
  background: rgba(14, 137, 55, 0.15);
  color: #ffffff;
  font-weight: 500;
  border-left: 3px solid #ffc107;
  border-radius: 0 8px 8px 0;
  margin-left: 0;
  padding-left: 13px;
}

.sidebar a.active i {
  color: #ffc107;
}

.sidebar a:hover:not(.active) {
  background-color: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  padding-left: 20px;
}

.sidebar a:hover i {
  color: #ffc107;
  transform: scale(1.1);
}

@media screen and (max-width: 700px) {
  .sidebar {
    position: relative;
    width: 100%;
    height: auto;
    padding: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }
  .sidebar a {
    margin: 0;
    flex: 1 1 auto;
    justify-content: center;
    border-radius: 6px;
  }
  .sidebar a.active {
    border-left: none;
    border-bottom: 3px solid #ffc107;
    border-radius: 6px;
    padding-left: 16px;
    background: rgba(14, 137, 55, 0.15);
  }
}
@media screen and (max-width: 400px) {
  .sidebar {
    flex-direction: column;
  }
  .sidebar a {
    width: 100%;
  }
}
</style>

